// extracted by mini-css-extract-plugin
export default {"container":"BlockInfo__container--1lL","isTopLine":"BlockInfo__isTopLine--1LQ"};